export default __webpack_public_path__ + "static/media/ADMISSAO-cracha.f137e178.png";